<template>
  <div class="registerHead" >
    <div class="headerCon clearfix">
      <a class="logo pull-left" @click="goToHref('/')"><img :src="webConfigInfo.companyLogoAttachmentUrl" :width="webConfigInfo.companyLogoWidth" :height="webConfigInfo.companyLogoHeight" alt=""></a>
      <h4><span class="line"></span>{{navTitle}}</h4>
      <p class="hasLogin hidden-xs pull-right">已有一链账号？<a @click="goToLogin">立即登录</a></p>
    </div>
  </div>
</template>
<script>
  import {customLoginButtonClick} from '@/assets/js/sensors'
  export default {
    props: ['navTitle','webConfigInfo'],
    methods: {
      goToHref(val){
        this.$router.push({path: val})
      },
      goToLogin () {
        try {
          customLoginButtonClick({page_title: "注册步骤页面"})
        } catch (e) {console.log(e)}
        this.$router.push({path:'/login'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/registerTop/index.vue